import React, { useState } from 'react';
import { Music2 } from 'lucide-react';
import { artworkUrl } from './campaignPresentation';
export default function CampaignArtwork({
  src,
  title,
  eager = false,
  onUnavailable,
}) {
  const resolved = artworkUrl(src);
  const [failedUrl, setFailedUrl] = useState('');
  const [loadedUrl, setLoadedUrl] = useState('');
  const tone =
    [...(title || 'Music')].reduce(
      (total, character) => total + character.charCodeAt(0),
      0
    ) % 4;
  const fail = () => {
    setFailedUrl(resolved);
    onUnavailable?.(resolved);
  };
  const fallback = !resolved || failedUrl === resolved;
  return (
    <div
      className={`tm-campaign-artwork ${
        !fallback && loadedUrl !== resolved ? 'is-loading' : ''
      }`}
    >
      {fallback ? (
        <div
          className={`tm-artwork-fallback tm-artwork-tone-${tone}`}
          role="img"
          aria-label={`Artwork unavailable for ${title}`}
        >
          <span className="tm-fallback-orbit" aria-hidden="true" />
          <Music2 size={32} strokeWidth={1.25} aria-hidden="true" />
          <span>TokenizeMe</span>
          <span className="tm-fallback-initials" aria-hidden="true">
            {title
              ?.split(/\s+/)
              .map((word) => word[0])
              .slice(0, 2)
              .join('')}
          </span>
        </div>
      ) : (
        <img
          src={resolved}
          alt={`${title} artwork`}
          loading={eager ? 'eager' : 'lazy'}
          decoding="async"
          onLoad={(event) => {
            // YouTube returns a 120 × 90 placeholder for unavailable larger thumbnails.
            if (
              /\/(?:img\.youtube\.com|i\.ytimg\.com)\//.test(resolved) &&
              event.currentTarget.naturalWidth <= 120
            )
              fail();
            else setLoadedUrl(resolved);
          }}
          onError={fail}
        />
      )}
    </div>
  );
}
